// @flow

import { get } from "lodash";
import type { TRootStore } from "../../types";



export const getFaqs = ({ help }: TRootStore) => {
	const sections = get(help.faqs, 'sections');
	const articles = get(help.faqs, 'articles');

	if(!sections || !articles){
		return [];
	}

	const sectionToOmit = window.location.pathname.includes('classic') ? 'Draft' : 'Classic';
	const sectionIdToOmit = sections.find(section => section.name.includes(sectionToOmit));
	const handledAccessorToOmit = sectionIdToOmit ? sectionIdToOmit.zendesk_section_id : 0;
	return articles.filter(article => 
		article.zendesk_section_id !== handledAccessorToOmit);
};

export const getFaqCats = ({help}: TRootStore) => {
	const sections = get(help.faqs, 'sections');
 	const sectionToOmit = window.location.pathname.includes('classic') 
		? 'Draft' : 'Classic';
	if(!sections) return [];

	return sections.filter(section => !section.name.includes(sectionToOmit));
};